import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Radio, Input } from 'antd';
import ProfilesTable from './Table/Table';
import TablePageSize from './TablePageSize/TablePageSize';
import { EMPLOYEES } from '../../../../common/constants/systemUrls';

import './Profiles.css';

const Profiles = props => {
  const {
    isLoading,
    typeProfiles,
    profiles,
    positionsProfiles,
    filterEmployeesRole,
    renderColumnsTable,
    paginationPageSize,
    handleChange,
    handleChangePagination,
    handleClickRow,
    rowKey,
    countActiveProfiles,
    countArchiveProfiles,
    countProfilesPosition,
    handleTypesEmployees,
    handleFilterEmployeesRole,
    handleSearch,
    searchValue,
  } = props;
  return (
    <div className="basicForm">
      <div className="employees">
        <div className="employees__header">
          <div className="employees__types">
            <Radio.Group
              defaultValue="active"
              size="large"
              onChange={handleTypesEmployees}
            >
              <Radio.Button
                className={
                  (typeProfiles === 'active' && 'button button_active') ||
                  'button'
                }
                value="active"
              >
                Активные: {countActiveProfiles}
              </Radio.Button>
              <Radio.Button
                className={
                  (typeProfiles === 'archive' && 'button button_active') ||
                  'button'
                }
                value="archive"
              >
                Архив: {countArchiveProfiles}
              </Radio.Button>
            </Radio.Group>
          </div>
          <Button type="primary" className="button button_add-employee">
            <Link to={'/' + EMPLOYEES + '/add/'}>Добавить сотрудника</Link>
          </Button>
        </div>
        <div className="employees__wrap">
          <div className="employees__filters">
            <div className="employees__group">
              <Radio.Group
                value={filterEmployeesRole}
                onChange={handleFilterEmployeesRole}
              >
                <Radio.Button key="all" value="all">
                  Все
                </Radio.Button>
                {positionsProfiles &&
                  positionsProfiles.map(item => {
                    let count =
                      (countProfilesPosition &&
                        countProfilesPosition[item.roleKey] &&
                        countProfilesPosition[item.roleKey]) ||
                      0;
                    return (
                      <Radio.Button
                        key={item.roleKey}
                        disabled={!count}
                        value={item.roleKey}
                      >
                        {item.role}: {count}
                      </Radio.Button>
                    );
                  })}
              </Radio.Group>
            </div>
            <Input.Search
              placeholder="Поиск по сотрудникам"
              onChange={handleSearch}
              allowClear={true}
              style={{ width: 224 }}
            />
          </div>
          <ProfilesTable
            isLoading={isLoading}
            profiles={profiles}
            rowKey={rowKey}
            renderColumns={renderColumnsTable}
            pageSize={paginationPageSize}
            handleChange={handleChange}
            handleClickRow={handleClickRow}
            searchValue={searchValue}
          />
          {profiles && profiles.length > 0 && (
            <TablePageSize
              handleChangePagination={handleChangePagination}
              pageSize={paginationPageSize}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Profiles;
